<nstar-search-select-control
	[container]="'body'"
	[placeholder]="placeholder"
	[searchFn]="searchFn"
	[selectItemMapper]="selectItemMapper"
	[changeValueMapper]="onChangeValueMapper"
	[resultTransformFn]="resultTransformFn"
	[formControl]="control"
	[minimumTermLength]="3"
	[attr.accesskey]="'c'"
></nstar-search-select-control>
